const state = {
   building: null,
   buildingId: null,
   buildingsList: [],
   currentAddress: null,
   buildingDefinition: null,
   fileSizeLimit: 9999999
}
const getters = {
   building: state => state.building,
   buildingId: state => state.buildingId,
   buildingsList: state => state.buildingsList,
   currentAddress: state => state.buildingsList,
   buildingDefinition: state => state.buildingDefinition,
   fileSizeLimit: state => state.fileSizeLimit,

}
const mutations = {
   buildingId(state, payload) {
      state.buildingId = payload
   },
   building(state, payload) {
      state.building = payload
   },
   buildingsList(state, payload) {
      state.buildingsList = payload
   },
   currentAddress(state, payload) {
      state.currentAddress = payload
   },
   setBuildingDefinition(state, payload) {
      state.buildingDefinition = payload
   },
   fileSizeLimit(state, payload) {
      state.fileSizeLimit = payload
   },
}
const actions = {
   setBuilding({ commit, state }, building) {
      commit('building', building)
      commit('buildingId', building._id)
      let strings = Array.isArray(building.strings) ? building.strings[0] :building.strings
      if (building.type) commit('setBuildingDefinition', strings)
   },
   setCurrentBuildingDefinitions({ commit, state }, buildingDefinition) {
      if (!buildingDefinition) return;
      // console.log('buildingDefinition');
      // console.log(buildingDefinition.name);
      commit('setBuildingDefinition', buildingDefinition)
   },
   setBuildingsList({ commit, state }, buildingsList) {
      commit('buildingsList', buildingsList)
   },
   setCurrentAddress({ commit, state }, currentAddress) {
      commit('currentAddress', currentAddress)
   },
   setFileSizeLimit({ commit, state }, fileSizeLimit) {
      commit('fileSizeLimit', fileSizeLimit)
   },
}

export default {
   actions,
   state,
   getters,
   mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/building.js